/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentBrowseStandardFlowsQuery from './__generated__/VirtualAgentBrowseStandardFlowsQuery$parameters';
import type { VirtualAgentBrowseStandardFlowsQuery as VirtualAgentBrowseStandardFlowsQueryType } from './__generated__/VirtualAgentBrowseStandardFlowsQuery.graphql';

type BrowseStandardFlowsEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentBrowseStandardFlowsQueryType;
	},
	{},
	{},
	{} | null
>;

export const browseStandardFlowsEntryPoint: EntryPoint<
	BrowseStandardFlowsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<BrowseStandardFlowsEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-browse-standard-flows" */ './VirtualAgentBrowseStandardFlows.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: VirtualAgentBrowseStandardFlowsQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
				},
			},
		},
	}),
});
